module.exports = __webpack_public_path__ + "img/banner3.9fdef7bf.png";